import React, { useEffect, useState } from 'react'
import { ButtonHLPure, InputHLPure, PanelBarGLPure, DropDownBtnHLPure, FormDatePicker, Traslates } from '../../pures'
import { changeFormatNumberToShow, convertStringInDates } from '../../../utils'

const FollowUpDocumentVarsPersonalized = (props) => {
    let {
        t,
        useSelected,
        entity,
        disableElements,
        variables,
        setVariables,
        optionsToUse,
        entitiesGrid,
        setEntitiesGrid,
        entityName
    } = props

    const typeVars = [
        {
            id: 0,
            name: t('followUpDocumentVarsPersonalized.type.vars.text')
        }, {
            id: 1,
            name: t('followUpDocumentVarsPersonalized.type.vars.amount')
        }, {
            id: 2,
            name: t('followUpDocumentVarsPersonalized.type.vars.date')
        },
    ];

    const [namevariable, setNameVariable] = useState('')
    const [valueVar, setValueVar] = useState('')
    const [typeVarSelected, setTypeVarSelected] = useState(0)
    const [errorInputTextVariable, setErrorInputTextVariable] = useState('')
    const [errorInputVariable, setErrorInputVariable] = useState(false)
    const [errorInputTextValue, setErrorInputTextValue] = useState('')
    const [errorInputValue, setErrorInputValue] = useState(false)

    const NewVariable = (props) => {
        return (
            <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-container-vars-array'>
                {
                    !props.item.disabled && (
                        <DropDownBtnHLPure
                            labelDropDown={t('digitalVaultFollowUpDocument.variable.format')}
                            optionsDropDown={typeVars}
                            onDropDownChange={(e) => handleChangeTypeVars(e, props.index)}
                            optionsValue={props.item.type}
                            valueItem='id'
                            nameOption='name'
                        />
                    )
                }
                <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-vars'>
                    <InputHLPure
                        typeInput='text'
                        labelInput={t('digitalVaultFollowUpDocument.variable.name')}
                        valueInput={props.item.variableName}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                        disabled={props.item.disabled}
                    />
                    {
                        props.item.type === 2 ? (
                            <div className=''>
                                <Traslates>
                                    <FormDatePicker
                                        id={'date'}
                                        name={'date'}
                                        format='dd-MM-yyyy'
                                        title={t('digitalVaultFollowUpDocument.variable.value')}
                                        onChange={(e) => handleChangeValueVars(e, props.index)}
                                        value={props.item.valueVariable}
                                        disabled={disableElements}
                                    />
                                </Traslates>
                            </div>
                        ) : (
                            <InputHLPure
                                typeInput='text'
                                labelInput={t('digitalVaultFollowUpDocument.variable.value')}
                                valueInput={props.item.valueVariable}
                                handleChangeInput={(e) => handleChangeValueVars(e, props.index)}
                                onBlur={(e) => onBlurValueVars(e, props.index)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                autoFocus={props.item.focusValue}
                                disabled={disableElements}
                            />
                        )
                    }
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (!useSelected || useSelected < 10) return
        if (useSelected === 10) {
            setValueVar(entity)
        } else {
            //Assign value of entity to a variable selected
            let optionSelected = optionsToUse.find((option) => option.value === useSelected)
            let value = ''
            let nameVar = ''
            let copyOptions = variables.map((variable) => {
                if (optionSelected.varId === variable.id) {
                    if (variable.typeData === 'number') {
                        entity = entity.replaceAll(',', '')
                        let numberConvert = changeFormatNumberToShow(entity, 1)
                        value = (numberConvert && numberConvert !== 'NaN') ? numberConvert : 0.00
                    } else if (variable.typeData === 'date') {
                        let dateConvert = convertStringInDates(entity)
                        value = (dateConvert) ? dateConvert.date : ''
                    } else {
                        value = entity
                    }

                    variable.valueVariable = value
                    nameVar = variable.variableName
                }
                return variable
            })

            //Agregar el nombre de las variables a la entidad
            let entities = [...entitiesGrid]
            entities = entities.map((entityCopy) => {
                if (entityCopy.name === entityName) {
                    entityCopy.use = nameVar
                }

                return entityCopy
            })

            setEntitiesGrid(entities)
            setVariables(copyOptions)
        }
    }, [useSelected])

    const handleChangeVariable = (e) => {
        setErrorInputTextVariable('')
        setErrorInputVariable(false)
        let value = e.target.value
        setNameVariable(value)
        let copyVars = [...variables]
        copyVars = copyVars.map((variable) => {
            variable.focusValue = false
            return variable
        })
        setVariables(copyVars)
    }

    const handleChangeValue = (e) => {
        setErrorInputTextValue('')
        setErrorInputValue(false)
        let value = e.target.value
        if (typeVarSelected === 1) {
            value = value.replace(/([^0-9.]+)/, '');
            value = value.replace(/^(0|\.)/, '');
        }

        setValueVar(value)
        let copyVars = [...variables]
        copyVars = copyVars.map((variable) => {
            variable.focusValue = false
            return variable
        })
        setVariables(copyVars)
    }

    const handleTypeVar = (e) => {
        let value = e.target.value
        value = (value) ? Number(value) : 0
        setValueVar('')
        setTypeVarSelected(value)
        let copyVars = [...variables]
        copyVars = copyVars.map((variable) => {
            variable.focusValue = false
            return variable
        })
        setVariables(copyVars)
    }

    const handleAddVar = () => {
        if (!namevariable || !valueVar) {
            if (!namevariable) {
                setErrorInputTextVariable(t('followUpDocumentVarsPersonalized.errors.add.name.var'))
                setErrorInputVariable(true)
            }

            if (!valueVar) {
                setErrorInputTextValue(t('followUpDocumentVarsPersonalized.errors.add.value.var'))
                setErrorInputValue(true)
            }
            return
        }

        let copyVars = [...variables]

        let variableName = namevariable
        let valueVariable = valueVar
        let typeData = 'text'

        if (typeVarSelected === 1) {
            let valueConvert = valueVar.replaceAll(',', '')
            let numberConvert = changeFormatNumberToShow(valueConvert, 1)
            valueVariable = (numberConvert && numberConvert !== 'NaN') ? numberConvert : 0
            typeData = 'number'
        }

        if (typeVarSelected === 2) {
            typeData = 'date'
        }

        let variableAdd = {
            variableName,
            typeData,
            valueVariable,
            type: typeVarSelected
        }

        copyVars.push(variableAdd)
        setVariables(copyVars)
        setValueVar('')
        setNameVariable('')
        setTypeVarSelected(0)
    }

    const handleChangeValueVars = (e, index) => {
        let value = e.target.value
        let copyVars = [...variables]

        if (copyVars[index].type === 1) {
            value = value.replace(/([^0-9.]+)/, '');
            value = value.replace(/^(0|\.)/, '');
        }

        copyVars[index].valueVariable = value
        copyVars = copyVars.map((variable, indexCopy) => {
            if (indexCopy === index) {
                variable.focusValue = true
            } else {
                variable.focusValue = false
            }
            return variable
        })
        setVariables(copyVars)
    }

    const handleChangeTypeVars = (e, index) => {
        let value = e.target.value
        let copyVars = [...variables]
        copyVars[index].type = Number(value)
        copyVars[index].valueVariable = ''
        copyVars = copyVars.map((variable) => {
            variable.focusValue = false
            return variable
        })
        setVariables(copyVars)
    }

    const onBlurValueVars = (e, index) => {
        let value = e.target.value
        let copyVars = [...variables]
        if (copyVars[index].type === 1) {
            value = value.replaceAll(',', '')
            let numberConvert = changeFormatNumberToShow(value, 1)
            value = (numberConvert && numberConvert !== 'NaN') ? numberConvert : 0.00
        }
        copyVars[index].valueVariable = value
        copyVars = copyVars.map((variable) => {
            variable.focusValue = false
            return variable
        })
        setVariables(copyVars)
    }

    return (
        <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('digitalVaultFollowUpDocument.variables.personalized')}
                id='followUpDocument-variables-personalized'
            >
                <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-container'>

                    {
                        variables.map((vari, index) => {
                            return (
                                <NewVariable
                                    {...props}
                                    item={vari}
                                    index={index}
                                />
                            )
                        })
                    }
                    <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-container-vars'>
                        <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-vars'>
                            <InputHLPure
                                typeInput='text'
                                labelInput={t('digitalVaultFollowUpDocument.variable.name')}
                                valueInput={namevariable}
                                handleChangeInput={(e) => handleChangeVariable(e)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                errorInputText={errorInputTextVariable}
                                errorInput={errorInputVariable}
                                disabled={disableElements}
                            />
                            <DropDownBtnHLPure
                                labelDropDown={t('digitalVaultFollowUpDocument.variable.format')}
                                optionsDropDown={typeVars}
                                onDropDownChange={(e) => handleTypeVar(e)}
                                valueItem='id'
                                nameOption='name'
                                disabled={disableElements}
                            />
                        </div>
                        {
                            typeVarSelected === 2 ? (
                                <div className=''>
                                    <Traslates>
                                        <FormDatePicker
                                            id={'date'}
                                            name={'date'}
                                            format='dd-MM-yyyy'
                                            title={t('digitalVaultFollowUpDocument.variable.value')}
                                            onChange={(e) => handleChangeValue(e)}
                                            value={valueVar}
                                            disabled={disableElements}
                                        />
                                    </Traslates>
                                </div>
                            ) : (
                                <InputHLPure
                                    typeInput='text'
                                    labelInput={t('digitalVaultFollowUpDocument.variable.value')}
                                    valueInput={valueVar}
                                    handleChangeInput={(e) => handleChangeValue(e)}
                                    tooltipShow={false}
                                    informationIcon={false}
                                    inputActive={true}
                                    errorInputText={errorInputTextValue}
                                    errorInput={errorInputValue}
                                    disabled={disableElements}
                                />
                            )
                        }
                    </div>
                    <div className='digitalVaultFollowUpDocument-followUpDocumentVarsPersonalized-btns-vars'>
                        {
                            disableElements === false && (
                                <ButtonHLPure
                                    nameBtn={t('btn.add')}
                                    onClickBtn={() => handleAddVar()}
                                />
                            )

                        }
                    </div>
                </div>
            </PanelBarGLPure>
        </div>

    )
}

export { FollowUpDocumentVarsPersonalized as default }